module.exports = __webpack_public_path__ + "img/undraw_Social_strategy_re_mk87.9bf99d4a.svg";